"use client"
import Head from 'next/head';
import Link from 'next/link';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { BiChevronRight } from 'react-icons/bi';
import { BsSearch } from 'react-icons/bs';
import { CgArrowLongDownC } from 'react-icons/cg';
import styles from '../../styles/default_theme/default_theme.module.css';

const DefaultTheme = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>
        <Head>
            <title>Funnel-Liner</title>
            <meta name='description' content='Generated by create next app' />
            <link rel='icon' href='/images/favicon.png' />
            <link rel='preconnect' href='https://fonts.googleapis.com' />
            <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
            <link
                href='https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap'
                rel='stylesheet'
            />
        </Head>

        <div className={styles.DefaultTheme}>

            {/* Menubar */}
            <section className={styles.Menubar}>

                <Container>

                    {/* DesktopMenu */}
                    <div className={styles.DesktopMenu}>

                        <Row className='d_flex'>

                            <Col lg={2}>

                                <div className={styles.Logo}>
                                    <Link href=''><img src="images/defalut_theme/logo.svg" alt="" /></Link>
                                </div>

                            </Col>

                            <Col lg={8}>

                                <div className={styles.MenuItem}>

                                    <ul>
                                        <li><Link href=''>Home</Link></li>
                                        <li><Link href=''>Products</Link></li>
                                        <li><Link href=''>About Us</Link></li>
                                        <li><Link href=''>Contact Us</Link></li>
                                    </ul>

                                </div>

                            </Col>

                            <Col lg={2}>

                                <div className={styles.Search}>

                                    <Link href='#'> <BsSearch/> </Link>
                                    <Link href='#'> <AiOutlineShoppingCart/> </Link>

                                </div>

                            </Col>

                        </Row>

                    </div>

                    {/* MobileMenu */}
                    <div className={styles.MobileMenu}>

                        <Row className='d_flex'>

                            <Col lg={3} xs={3}>

                                <div className={styles.Logo}>
                                    <Link href=''><img src="images/defalut_theme/logo.svg" alt="" /></Link>
                                </div>

                            </Col>

                            <Col lg={9} xs={9}>

                                <div className={styles.MobileRight}>

                                    <button onClick={handleShow}>
                                        <img src="images/defalut_theme/menu.png" alt="" />
                                    </button>

                                <Offcanvas show={show} onHide={handleClose}>

                                    <Offcanvas.Header closeButton>
                                    </Offcanvas.Header>

                                    <Offcanvas.Body>

                                        <div className={styles.MenuItem}>

                                            <ul>
                                                <li><Link href=''>Home</Link></li>
                                                <li><Link href=''>Products</Link></li>
                                                <li><Link href=''>About Us</Link></li>
                                                <li><Link href=''>Contact Us</Link></li>
                                            </ul>

                                        </div>

                                        <div className={styles.Search}>

                                            <Link href=''> <BsSearch/> </Link>
                                            <Link href=''> <AiOutlineShoppingCart/> </Link>

                                        </div>

                                    </Offcanvas.Body>

                                </Offcanvas>

                                </div>

                            </Col>

                        </Row>

                    </div>


                </Container>

            </section>

                        {/* MiddleSection */}
                        <section className={styles.MiddleSection}>

<Container>

    <Row className="justify-content-md-center">

        <Col lg={6}>

            <div className={styles.MiddleSectionContent}>

                <div className={styles.img}>
                    <img src="images/defalut_theme/error.svg" alt="" />
                </div>

                <div className={styles.text}>
                    <p>No Product Added</p>

                    <div className={styles.DownArrow}></div>

                    <Link href='https://dashboard.funnelliner.com/add-category'>Add Category</Link>

                    <div className={styles.DownArrow2}>
                        <CgArrowLongDownC/>
                    </div>

                    <Link href='https://dashboard.funnelliner.com/add-product' className={styles.two}>Add Products</Link>

                    <div className={styles.DownArrow}>
                        <CgArrowLongDownC/>
                    </div>

                    <Link href='https://dashboard.funnelliner.com/multi-page'>Add New Page</Link>

                </div>

            </div>

        </Col>

    </Row>

</Container>

</section>

            {/* Footer */}
            <section className={styles.Footer}>

                <Container>

                    <Row>

                        <Col lg={6} sm={6}>

                            <div className={styles.FooterLogo}>

                                <div className={styles.img}>
                                    <img src="images/defalut_theme/logo.svg" alt="" />
                                </div>

                                <div className={styles.text}>
                                    <h3>Company Info</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ornare cursus sed nunc eget dictum  Sed ornare cursus sed nunc eget dictumd nunc eget dictum  Sed ornare cursus sed nunc eget dictum  </p>
                                </div>

                            </div>

                        </Col>

                        <Col lg={3} sm={3}>

                            <div className={styles.FooterItem}>

                                <h3>Main Menu</h3>

                                <ul>

                                    <li> <Link href=''> <BiChevronRight/> Home</Link> </li>
                                    <li> <Link href=''> <BiChevronRight/> Shop</Link> </li>
                                    <li> <Link href=''> <BiChevronRight/> About Us</Link> </li>
                                    <li> <Link href=''> <BiChevronRight/> Contact Us</Link> </li>

                                </ul>

                            </div>

                        </Col>

                        <Col lg={3} sm={3}>

                            <div className={styles.FooterItem}>

                                <h3>Other Links</h3>

                                <ul>

                                    <li> <Link href=''> <BiChevronRight/> Privacy Policy</Link> </li>
                                    <li> <Link href=''> <BiChevronRight/> Terms & Condition</Link> </li>

                                </ul>

                            </div>

                        </Col>

                    </Row>

                </Container>

            </section>

        </div>
        </>
    )

}

export default DefaultTheme
